import { observable, action } from "mobx";
import _ from "lodash";
class User {
  constructor() {
    if (localStorage.user === undefined) this.user = null;
    else {
      try {
        this.user = JSON.parse(localStorage.user);
      } catch (e) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("adminToken");
        localStorage.removeItem("adminUser");
        location.reload();
      }
    }
  }

  @observable user = {};

  @action setUser = newUser => {
    if (newUser === null) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    } else localStorage.setItem("user", JSON.stringify(newUser));
    this.user = newUser;
  };

  getUser = () => {
    return this.user;
  };

  userLoggedIn = () => {
    return this.user != null;
  };

  @action loginUser = user => {
    this.user = user;
  };

  @action setUserCoach = () => {
    this.user = _.assign({}, this.user, { role: "coach" });
    localStorage.setItem("user", JSON.stringify(this.user));
  };
}

export default new User();



// WEBPACK FOOTER //
// ./src/stores/User.js